// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a4e125a2","622":"96e03297","977":"8f160204"}[chunkId] + ".chunk.js";
};